'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _StoryPreview = require('./components/StoryPreview');

var _StoryPreview2 = _interopRequireDefault(_StoryPreview);

var _FooterDocs = require('./components/FooterDocs');

var _FooterDocs2 = _interopRequireDefault(_FooterDocs);

var _common = require('../common');

var _common2 = _interopRequireDefault(_common);

var _highlite = require('../../services/highlite');

var _highlite2 = _interopRequireDefault(_highlite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Story = function (_React$Component) {
  _inherits(Story, _React$Component);

  function Story() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Story);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Story.__proto__ || Object.getPrototypeOf(Story)).call.apply(_ref, [this].concat(args))), _this), _this.ref = null, _this.state = {
      asProxy: false
    }, _this.handleRef = function (ref) {
      _this.ref = ref;
      _this.highlight();

      if (_this.ref) {
        var childrenReadmeDocs = _this.ref.querySelector('.storybook-readme-story');

        if (childrenReadmeDocs) {
          _this.setState({
            asProxy: true
          });
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Story, [{
    key: 'highlight',
    value: function highlight() {
      if (this.ref) {
        (0, _highlite2.default)(this.ref, {
          withJSX: true
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.highlight();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          storyFn = _props.storyFn,
          story = _props.story,
          kind = _props.kind,
          config = _props.config,
          _props$docs = _props.docs,
          docsAfterPreview = _props$docs.docsAfterPreview,
          docsBeforePreview = _props$docs.docsBeforePreview;


      var PreviewComponent = config.PreviewComponent || _StoryPreview2.default;
      var FooterComponent = config.FooterComponent || _FooterDocs2.default;

      if (this.state.asProxy) {
        return storyFn({ kind: kind, story: story });
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'storybook-readme-story',
          style: { padding: '8px' },
          ref: this.handleRef
        },
        docsBeforePreview && docsBeforePreview.map(function (doc, index) {
          return _react2.default.createElement('div', {
            key: index,
            className: 'markdown-body',
            dangerouslySetInnerHTML: { __html: doc }
          });
        }),
        _react2.default.createElement(
          PreviewComponent,
          null,
          storyFn({ kind: kind, story: story })
        ),
        docsAfterPreview && docsAfterPreview.map(function (doc, index) {
          return _react2.default.createElement('div', {
            key: index,
            className: 'markdown-body',
            dangerouslySetInnerHTML: { __html: doc }
          });
        }),
        config.docsAtFooter && _react2.default.createElement(
          FooterComponent,
          null,
          _react2.default.createElement('div', {
            className: 'markdown-body',
            dangerouslySetInnerHTML: { __html: config.docsAtFooter }
          })
        )
      );
    }
  }]);

  return Story;
}(_react2.default.Component);

function withDocsCallAsHoc(_ref2) {
  var docs = _ref2.docs,
      config = _ref2.config,
      storyFn = _ref2.storyFn;

  return function (_ref3) {
    var kind = _ref3.kind,
        story = _ref3.story;
    return _react2.default.createElement(Story, {
      docs: docs,
      config: config,
      storyFn: storyFn,
      kind: kind,
      story: story
    });
  };
}

function withDocsCallAsDecorator(_ref4) {
  var docs = _ref4.docs,
      config = _ref4.config;

  return function (storyFn, _ref5) {
    var kind = _ref5.kind,
        story = _ref5.story;
    return _react2.default.createElement(Story, {
      docs: docs,
      config: config,
      storyFn: storyFn,
      kind: kind,
      story: story
    });
  };
}

function doc(_ref6) {
  var docs = _ref6.docs,
      config = _ref6.config;

  return function (_ref7) {
    var kind = _ref7.kind,
        story = _ref7.story;
    return _react2.default.createElement(Story, {
      docs: {},
      config: Object.assign({}, config, {
        PreviewComponent: function PreviewComponent(_ref8) {
          var children = _ref8.children;
          return _react2.default.createElement(
            'div',
            null,
            children
          );
        }
      }),
      storyFn: function storyFn() {
        return docs.map(function (doc, index) {
          return _react2.default.createElement('div', {
            key: index,
            className: 'markdown-body',
            dangerouslySetInnerHTML: { __html: doc }
          });
        });
      },
      kind: kind,
      story: story
    });
  };
}

exports.default = {
  doc: doc,
  withReadme: _common2.default.withReadme,
  withDocs: {
    callAsDecorator: withDocsCallAsDecorator,
    callAsHoc: withDocsCallAsHoc
  }
};